// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"a047810b","453":"14cb9627","595":"3a3b0420","695":"232696f5","778":"ec77cf88","981":"b3d59811"}[chunkId] + ".chunk.js";
};